import { createSelector } from "reselect";

const cursorSelector = (state) => state.cursor;

export const cursorTypeSelector = createSelector(
  cursorSelector,
  (cursor) => cursor.type
);
